import { ApiProperty } from '@nestjs/swagger';
import type { ApiServerEntityIDType } from '../../../types';
import { AttachmentType } from './type';

export class AttachmentViewModel {
  @ApiProperty()
  id: ApiServerEntityIDType;

  @ApiProperty()
  src: string;

  @ApiProperty({ enum: AttachmentType, enumName: 'AttachmentType' })
  type: AttachmentType;

  @ApiProperty()
  durationInMs?: number;

  @ApiProperty()
  updatedAt: string;

  @ApiProperty()
  createdAt: string;
}
